import { createSlice } from '@reduxjs/toolkit';
import { uploadClinicLogoApi } from '../../../rtk-apis/clinics/uploadClinicLogo';

const initialState = {
  status: '',
  result: null,
  msg: '',
  loading: false,
  error: '',
};

const uploadClinicLogoApiSlice = createSlice({
  name: 'uploadClinicLogo',
  initialState,
  reducers: {
    clearState: state => {
      state.status = '';
      state.result = null;
      state.msg = '';
      state.loading = false;
      state.error = '';
    },
  },
  extraReducers: builder => {
    builder
      .addCase(uploadClinicLogoApi.pending, (state, action) => {
        state.loading = true;
      })
      .addCase(uploadClinicLogoApi.fulfilled, (state, action) => {
        state.loading = false;
        state.status = 'SUCCESS';
        state.result = action?.payload;
        state.msg = action?.payload?.msg;
      })
      .addCase(uploadClinicLogoApi.rejected, (state, action) => {
        state.loading = false;
        state.status = 'ERROR';
        state.result = null;
        state.msg = (action?.payload as string) || 'Something went wrong!';
      });
  },
});

export default uploadClinicLogoApiSlice.reducer;
export const { clearState } = uploadClinicLogoApiSlice.actions;
